import React, { useState } from "react";
import { BorderLeftOutlined, BorderHorizontalOutlined, BorderRightOutlined, BorderTopOutlined, BorderBottomOutlined, BorderVerticleOutlined } from '@ant-design/icons';
import { Space } from "antd";

export default function PositionAlign(props) {

    const { type = "horizontal", value = "center", onChange = () => { } } = props;

    const [current, setCurrent] = useState(value);

    const save = (_e) => {
        setCurrent(_e);
        onChange(_e);
    }

    if (type === "horizontal") {
        return (
            <Space>
                <div><BorderLeftOutlined onClick={() => save("left")} style={{ "color": (current === "left") ? "#1890ff" : "#AAA" }} /></div>
                <div><BorderHorizontalOutlined onClick={() => save("center")} style={{ "color": (current === "center") ? "#1890ff" : "#AAA" }} /></div>
                <div><BorderRightOutlined onClick={() => save("right")} style={{ "color": (current === "right") ? "#1890ff" : "#AAA" }} /></div>
            </Space>
        )
    } else {

        return (
            <Space>
                <div><BorderTopOutlined onClick={() => save("top")} style={{ "color": (current === "top") ? "#1890ff" : "#AAA" }} /></div>
                <div><BorderVerticleOutlined onClick={() => save("center")} style={{ "color": (current === "center") ? "#1890ff" : "#AAA" }} /></div>
                <div><BorderBottomOutlined onClick={() => save("bottom")} style={{ "color": (current === "bottom") ? "#1890ff" : "#AAA" }} /></div>
            </Space>
        )

    }

}